module.exports = __webpack_public_path__ + "img/category-box.6c819e19.svg";